module.exports = "pegasus/assets/pexels-photo-2.png";